import { PricingInfo } from '../../modules/CreditSystem/types';
import { SubscriptionPlanType } from './entities';

export type PremiumPlanProduct = {
  startingPrice: PricingInfo | null;
  variantDetail: PremiumPlan;
};

export type PremiumPlan = {
  hasVIPMembership: boolean;
  hasJobExternalUrl: boolean;
  hasCSVDownload: boolean;
} & (
  | {
      planType: typeof SubscriptionPlanType.UNLIMITED;
      minConcurrentJobSlots: null;
      maxConcurrentJobSlots: null;
    }
  | {
      planType: typeof SubscriptionPlanType.CUSTOMIZED;
      minConcurrentJobSlots: number | null;
      maxConcurrentJobSlots: number | null;
    }
  | {
      planType: Exclude<SubscriptionPlanType, 'UNLIMITED' | 'CUSTOMIZED'>;
      minConcurrentJobSlots: number;
      maxConcurrentJobSlots: number;
    }
);

export const PurchaseSupportedPremiumPlanType = [
  SubscriptionPlanType.GROWTH,
  SubscriptionPlanType.SCALE,

  // this is supported for FPAL purchase modal only
  SubscriptionPlanType.UNLIMITED,
] as const;

export type PurchaseSupportedPremiumPlanType =
  (typeof PurchaseSupportedPremiumPlanType)[number];
